import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './App.css';

// The catch-all route. Hosting rewrites every unknown path to index.html, so
// without this an unknown URL rendered the nav bar over an empty page.
// Hosting still answers 200, so tell search engines not to index the page.

const destinations = [
  { path: '/downloads', title: 'Downloads', desc: 'mChatAI for iPhone, iPad, Mac and Android' },
  { path: '/hub', title: 'Hub', desc: 'Games, mini-apps and tours people have made' },
  { path: '/features', title: 'Features', desc: 'Every applet, with pictures' },
  { path: '/blog', title: 'Blog', desc: 'How-tos and things we built' },
  { path: '/docs', title: 'Docs', desc: 'Getting started and help' },
  { path: '/', title: 'Home', desc: 'Start at the beginning' },
];

export default function NotFoundPage() {
  const { pathname } = useLocation();

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Page not found — mChatAI';
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);
    return () => {
      document.title = previousTitle;
      robots.remove();
    };
  }, []);

  return (
    <div className="mp-page" style={{ background: '#fff' }}>
      <section style={{ textAlign: 'center', padding: '64px 24px 32px', maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 800, color: '#111827', margin: '0 0 12px' }}>
          Page not found
        </h1>
        <p style={{ fontSize: '1rem', color: '#6b7280', lineHeight: 1.6, margin: 0 }}>
          There is nothing at <code style={{ background: '#f3f4f6', padding: '2px 6px', borderRadius: 4, wordBreak: 'break-all' }}>{pathname}</code>.
          It may have moved, or the link may have a typo. One of these may be what you were after.
        </p>
      </section>

      <section style={{ maxWidth: 820, margin: '0 auto 64px', padding: '0 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
          {destinations.map((d) => (
            <Link key={d.path} to={d.path} className="mp-card-link">
              <div className="mp-card" style={{ padding: 20, height: '100%', boxSizing: 'border-box' }}>
                <h2 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#111827', margin: '0 0 4px' }}>{d.title}</h2>
                <p style={{ fontSize: '0.85rem', color: '#6b7280', lineHeight: 1.5, margin: 0 }}>{d.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
